<template>
	<div>
		<h1><translate>Monthly Reconciliation</translate></h1>
		<v-card max-width="510px">
			<v-card-title><translate>Invoice Reconciliation</translate></v-card-title>
			<v-card-text>
				<translate>The previous month is</translate>
				<v-switch
					v-model="invoicePreviousMonth"
					color="primary"
					:label="invoicePreviousMonthStatus"
				/>
				<translate>All previous months are</translate>
				<v-switch
					v-model="invoiceAllPreviousMonths"
					color="primary"
					:label="invoiceAllPreviousMonthsStatus"
				/>
				<h1><translate>Payment Reconciliation</translate></h1>
				<translate>The previous month is</translate>
				<v-switch
					v-model="paymentPreviousMonth"
					color="primary"
					:label="paymentPreviousMonthStatus"
				/>
				<translate>All previous months are</translate>
				<v-switch
					v-model="paymentAllPreviousMonths"
					color="primary"
					:label="paymentAllPreviousMonthsStatus"
				/>
				<v-spacer />
				<v-btn
					color="primary"
					@click="requestUpdate"
				>
					<translate>Save</translate>
				</v-btn>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'MonthlyReconciliation',
	data () {
		return {
			invoicePreviousMonth: false,
			invoiceAllPreviousMonths: false,
			currentInvoicePreviousMonth: false,
			currentInvoiceAllPreviousMonths: false,
			paymentPreviousMonth: false,
			paymentAllPreviousMonths: false,
			currentPaymentPreviousMonth: false,
			currentPaymentAllPreviousMonths: false,
		};
	},

	computed: {
		paymentPreviousMonthStatus () {
			return this.paymentPreviousMonth ? this.$gettext('Open') : this.$gettext('Closed');
		},
		paymentAllPreviousMonthsStatus () {
			return this.paymentAllPreviousMonths ? this.$gettext('Open') : this.$gettext('Closed');
		},
		invoicePreviousMonthStatus () {
			return this.invoicePreviousMonth ? this.$gettext('Open') : this.$gettext('Closed');
		},
		invoiceAllPreviousMonthsStatus () {
			return this.invoiceAllPreviousMonths ? this.$gettext('Open') : this.$gettext('Closed');
		}
	},

	mounted () {
		this.requestGetStatus();
	},
	methods: {
		/**
		 * Update the reconcilliations
		 *
		 * @returns {void}
		 */
		requestUpdate () {
			if (this.currentInvoicePreviousMonth === this.invoicePreviousMonth && this.currentInvoiceAllPreviousMonths === this.invoiceAllPreviousMonths &&
				this.currentPaymentPreviousMonth === this.paymentPreviousMonth && this.currentPaymentAllPreviousMonths === this.paymentAllPreviousMonths) {
				return;
			}
			axios.post('/bo/finance/monthlyreconciliation', {
				invoicePreviousMonth: this.currentInvoicePreviousMonth !== this.invoicePreviousMonth ? this.invoicePreviousMonth : null,
				invoiceAllPreviousMonths: this.currentInvoiceAllPreviousMonths !== this.invoiceAllPreviousMonths ? this.invoiceAllPreviousMonths : null,
				paymentPreviousMonth: this.currentPaymentPreviousMonth !== this.paymentPreviousMonth ? this.paymentPreviousMonth : null,
				paymentAllPreviousMonths: this.currentPaymentAllPreviousMonths !== this.paymentAllPreviousMonths ? this.paymentAllPreviousMonths : null,
			})
				.then(() => {
					displayError(this.$gettext('Successfully changed reconciliation'));
					this.currentInvoiceAllPreviousMonths = this.invoiceAllPreviousMonths;
					this.currentInvoicePreviousMonth = this.invoicePreviousMonth;
					this.currentPaymentAllPreviousMonths = this.paymentAllPreviousMonths;
					this.currentPaymentPreviousMonth = this.paymentPreviousMonth;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during update request'));
				});
		},

		/**
		 * Get and set the current status of reconcilliations
		 *
		 * @returns {void}
		 */
		requestGetStatus () {
			axios.get('/bo/finance/monthlyreconciliation/status')
				.then(({
					data: data
				}) => {
					this.invoicePreviousMonth = data.invoice[0]['Previous month'] === 1;
					this.invoiceAllPreviousMonths = data.invoice[1]['All months'] === 1;
					this.currentInvoicePreviousMonth = data.invoice[0]['Previous month'] === 1;
					this.currentInvoiceAllPreviousMonths = data.invoice[1]['All months'] === 1;

					this.paymentPreviousMonth = data.payment[0]['Previous month'] === 1;
					this.paymentAllPreviousMonths = data.payment[1]['All months'] === 1;
					this.currentPaymentPreviousMonth = data.payment[0]['Previous month'] === 1;
					this.currentPaymentAllPreviousMonths = data.payment[1]['All months'] === 1;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during status request'));
				});
		}
	}
};
</script>

<style scoped>

</style>
